import { render } from "./app-button-upload-image.vue?vue&type=template&id=46df8030"
import script from "./app-button-upload-image.vue?vue&type=script&lang=js"
export * from "./app-button-upload-image.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/button/app-button-upload-image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46df8030"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46df8030', __exports__)) {
    console.log('reload')
    api.reload('46df8030', __exports__)
  }
  
  module.hot.accept("./app-button-upload-image.vue?vue&type=template&id=46df8030", () => {
    console.log('re-render')
    api.rerender('46df8030', render)
  })

}


export default __exports__